
// Keeping register as a relay functions for all those calls that come from diferent places
// instead of oing and chaning all those places to signUpProfile


import signUpProfile from "../sign-up_profile/signUpProfile";

class Register {
  _displayOptions(actionAfter, title = "Cuenta necesaria", open = "none") {
    signUpProfile._open();
  }
}
export default new Register();
